/*
 * Generated type guards for "column.dto.ts".
 * WARNING: Do not manually change this file.
 */
import { isParaValuesVersusDepth } from '../../../jobsites-management/jobsite-summary/models/stats.dto.type.guard'
import {
  ColumnDto,
  ColumnKey,
  ColumnValues,
  ColumnLink,
  ColumnLinkArray,
  ColumnComment,
  DailyDiaryValue,
} from './column.dto'
import { HFType } from '../../constants/hf-type.enum'

export function isColumnDto(obj: unknown): obj is ColumnDto {
  const typedObj = obj as ColumnDto
  return (
    ((typedObj !== null && typeof typedObj === 'object') ||
      typeof typedObj === 'function') &&
    (isColumnKey(typedObj['key']) as boolean) &&
    ((typedObj['values'] !== null && typeof typedObj['values'] === 'object') ||
      typeof typedObj['values'] === 'function') &&
    (typeof typedObj['values']['targetDepth'] === 'undefined' ||
      typeof typedObj['values']['targetDepth'] === 'number') &&
    (typeof typedObj['values']['thrustPresCriterion'] === 'undefined' ||
      typeof typedObj['values']['thrustPresCriterion'] === 'number') &&
    (typeof typedObj['values']['thrustCriterion'] === 'undefined' ||
      typeof typedObj['values']['thrustCriterion'] === 'number') &&
    (typeof typedObj['values']['anchorageLayer'] === 'undefined' ||
      typeof typedObj['values']['anchorageLayer'] === 'number') &&
    (typeof typedObj['values']['torquePresCriterion'] === 'undefined' ||
      typeof typedObj['values']['torquePresCriterion'] === 'number') &&
    (typeof typedObj['values']['torqueCriterion'] === 'undefined' ||
      typeof typedObj['values']['torqueCriterion'] === 'number') &&
    (typeof typedObj['values']['energyCriterion'] === 'undefined' ||
      typeof typedObj['values']['energyCriterion'] === 'number') &&
    (isColumnValues(typedObj['values']) as boolean) &&
    (typeof typedObj['stats'] === 'undefined' ||
      (((typedObj['stats'] !== null && typeof typedObj['stats'] === 'object') ||
        typeof typedObj['stats'] === 'function') &&
        Object.entries<any>(typedObj['stats']).every(
          ([key, value]) =>
            ((value !== null && typeof value === 'object') ||
              typeof value === 'function') &&
            Object.entries<any>(value).every(
              ([key, value]) =>
                typeof value === 'number' && typeof key === 'string',
            ) &&
            typeof key === 'string',
        ))) &&
    (typeof typedObj['stats3d'] === 'undefined' ||
      (((typedObj['stats3d'] !== null &&
        typeof typedObj['stats3d'] === 'object') ||
        typeof typedObj['stats3d'] === 'function') &&
        Object.entries<any>(typedObj['stats3d']).every(
          ([key, value]) =>
            ((value !== null && typeof value === 'object') ||
              typeof value === 'function') &&
            Object.entries<any>(value).every(
              ([key, value]) =>
                Array.isArray(value) &&
                value.every(
                  (e: any) => isParaValuesVersusDepth(e) as boolean,
                ) &&
                typeof key === 'string',
            ) &&
            typeof key === 'string',
        ))) &&
    Array.isArray(typedObj['links']) &&
    typedObj['links'].every((e: any) => isColumnLink(e) as boolean)
  )
}

export function isColumnKey(obj: unknown): obj is ColumnKey {
  const typedObj = obj as ColumnKey
  return (
    ((typedObj !== null && typeof typedObj === 'object') ||
      typeof typedObj === 'function') &&
    typeof typedObj['id'] === 'string' &&
    typeof typedObj['name'] === 'string' &&
    (typeof typedObj['process'] === 'undefined' ||
      typedObj['process'] === 'DMX' ||
      typedObj['process'] === 'HF' ||
      typedObj['process'] === 'JTC' ||
      typedObj['process'] === 'KS' ||
      typedObj['process'] === 'PFA' ||
      typedObj['process'] === 'PFC' ||
      typedObj['process'] === 'SBP' ||
      typedObj['process'] === 'SMX' ||
      typedObj['process'] === 'TCT' ||
      typedObj['process'] === 'VBF' ||
      typedObj['process'] === 'EPF' ||
      typedObj['process'] === 'TLK') &&
    (typeof typedObj['type'] === 'undefined' ||
      typedObj['type'] === HFType.PILE ||
      typedObj['type'] === HFType.MERLON ||
      typedObj['type'] === HFType.PANEL)
  )
}

export function isColumnValues(obj: unknown): obj is ColumnValues {
  const typedObj = obj as ColumnValues
  return (
    ((typedObj !== null && typeof typedObj === 'object') ||
      typeof typedObj === 'function') &&
    (typeof typedObj['cage'] === 'undefined' ||
      typeof typedObj['cage'] === 'string') &&
    (typeof typedObj['localX'] === 'undefined' ||
      typeof typedObj['localX'] === 'number') &&
    (typeof typedObj['localY'] === 'undefined' ||
      typeof typedObj['localY'] === 'number') &&
    (typeof typedObj['computedLocalX'] === 'undefined' ||
      typeof typedObj['computedLocalX'] === 'number') &&
    (typeof typedObj['computedLocalY'] === 'undefined' ||
      typeof typedObj['computedLocalY'] === 'number') &&
    (typeof typedObj['nbr'] === 'undefined' ||
      typeof typedObj['nbr'] === 'number') &&
    (typeof typedObj['polygon'] === 'undefined' ||
      typeof typedObj['polygon'] === 'string') &&
    (typeof typedObj['width'] === 'undefined' ||
      typeof typedObj['width'] === 'number') &&
    (typeof typedObj['length'] === 'undefined' ||
      typeof typedObj['length'] === 'number') &&
    (typeof typedObj['prodDiameter'] === 'undefined' ||
      typeof typedObj['prodDiameter'] === 'number') &&
    (typeof typedObj['subtype'] === 'undefined' ||
      typeof typedObj['subtype'] === 'string') &&
    (typeof typedObj['type'] === 'undefined' ||
      typeof typedObj['type'] === 'string') &&
    (typeof typedObj['platformLevel'] === 'undefined' ||
      typeof typedObj['platformLevel'] === 'number') &&
    (typeof typedObj['topLevel'] === 'undefined' ||
      typeof typedObj['topLevel'] === 'number') &&
    (typeof typedObj['alert'] === 'undefined' ||
      typeof typedObj['alert'] === 'string') &&
    (typeof typedObj['axeAngle'] === 'undefined' ||
      typeof typedObj['axeAngle'] === 'number') &&
    (typeof typedObj['axeDistance'] === 'undefined' ||
      typeof typedObj['axeDistance'] === 'number') &&
    (typeof typedObj['diameter'] === 'undefined' ||
      typeof typedObj['diameter'] === 'number') &&
    (typeof typedObj['latitude'] === 'undefined' ||
      typeof typedObj['latitude'] === 'number') &&
    (typeof typedObj['longitude'] === 'undefined' ||
      typeof typedObj['longitude'] === 'number') &&
    (typeof typedObj['columnType'] === 'undefined' ||
      typeof typedObj['columnType'] === 'string') &&
    (typeof typedObj['zone'] === 'undefined' ||
      typeof typedObj['zone'] === 'string') &&
    (typeof typedObj['discarded'] === 'undefined' ||
      typedObj['discarded'] === false ||
      typedObj['discarded'] === true) &&
    (typeof typedObj['soilInvestigation'] === 'undefined' ||
      typeof typedObj['soilInvestigation'] === 'string') &&
    (typeof typedObj['isDataAvailable'] === 'undefined' ||
      typedObj['isDataAvailable'] === false ||
      typedObj['isDataAvailable'] === true) &&
    (typeof typedObj['parentId'] === 'undefined' ||
      typeof typedObj['parentId'] === 'string') &&
    (typeof typedObj['panelOrder'] === 'undefined' ||
      typeof typedObj['panelOrder'] === 'number') &&
    (typeof typedObj['panelPhasing'] === 'undefined' ||
      typeof typedObj['panelPhasing'] === 'string') &&
    (typeof typedObj['lineRatio'] === 'undefined' ||
      typeof typedObj['lineRatio'] === 'number') &&
    (typeof typedObj['lineString'] === 'undefined' ||
      typeof typedObj['lineString'] === 'string')
  )
}

export function isColumnLink(obj: unknown): obj is ColumnLink {
  const typedObj = obj as ColumnLink
  return (
    ((typedObj !== null && typeof typedObj === 'object') ||
      typeof typedObj === 'function') &&
    (typeof typedObj['id'] === 'undefined' ||
      typeof typedObj['id'] === 'string') &&
    (typeof typedObj['idData'] === 'undefined' ||
      typeof typedObj['idData'] === 'string') &&
    (typeof typedObj['idCage'] === 'undefined' ||
      typeof typedObj['idCage'] === 'string') &&
    (typeof typedObj['idConcrete'] === 'undefined' ||
      typeof typedObj['idConcrete'] === 'string') &&
    (typeof typedObj['url'] === 'undefined' ||
      typeof typedObj['url'] === 'string') &&
    (typeof typedObj['nameFull'] === 'undefined' ||
      typeof typedObj['nameFull'] === 'string') &&
    (typeof typedObj['nameShort'] === 'undefined' ||
      typeof typedObj['nameShort'] === 'string') &&
    (typeof typedObj['icon'] === 'undefined' ||
      typeof typedObj['icon'] === 'string')
  )
}

export function isColumnLinkArray(obj: unknown): obj is ColumnLinkArray {
  const typedObj = obj as ColumnLinkArray
  return (
    Array.isArray(typedObj) &&
    typedObj.every((e: any) => isColumnLink(e) as boolean)
  )
}

export function isColumnComment(obj: unknown): obj is ColumnComment {
  const typedObj = obj as ColumnComment
  return (
    ((typedObj !== null && typeof typedObj === 'object') ||
      typeof typedObj === 'function') &&
    (typeof typedObj['id'] === 'undefined' ||
      typeof typedObj['id'] === 'string') &&
    (typeof typedObj['jobsiteId'] === 'undefined' ||
      typeof typedObj['jobsiteId'] === 'string') &&
    (typeof typedObj['columnId'] === 'undefined' ||
      typeof typedObj['columnId'] === 'string') &&
    (typeof typedObj['columnName'] === 'undefined' ||
      typeof typedObj['columnName'] === 'string') &&
    (typeof typedObj['comment'] === 'undefined' ||
      typeof typedObj['comment'] === 'string') &&
    (typeof typedObj['createdAt'] === 'undefined' ||
      typeof typedObj['createdAt'] === 'string') &&
    (typeof typedObj['lastUpdate'] === 'undefined' ||
      typedObj['lastUpdate'] === null ||
      typeof typedObj['lastUpdate'] === 'string' ||
      typeof typedObj['lastUpdate'] === 'number' ||
      (typedObj['lastUpdate'] instanceof Object &&
        typeof typedObj['lastUpdate']['format'] === 'function' &&
        typeof typedObj['lastUpdate']['startOf'] === 'function' &&
        typeof typedObj['lastUpdate']['endOf'] === 'function' &&
        typeof typedObj['lastUpdate']['add'] === 'function' &&
        typeof typedObj['lastUpdate']['add'] === 'function' &&
        typeof typedObj['lastUpdate']['subtract'] === 'function' &&
        typeof typedObj['lastUpdate']['subtract'] === 'function' &&
        typeof typedObj['lastUpdate']['calendar'] === 'function' &&
        typeof typedObj['lastUpdate']['calendar'] === 'function' &&
        typeof typedObj['lastUpdate']['calendar'] === 'function' &&
        typeof typedObj['lastUpdate']['clone'] === 'function' &&
        typeof typedObj['lastUpdate']['valueOf'] === 'function' &&
        typeof typedObj['lastUpdate']['local'] === 'function' &&
        typeof typedObj['lastUpdate']['isLocal'] === 'function' &&
        typeof typedObj['lastUpdate']['utc'] === 'function' &&
        typeof typedObj['lastUpdate']['isUTC'] === 'function' &&
        typeof typedObj['lastUpdate']['isUtc'] === 'function' &&
        typeof typedObj['lastUpdate']['parseZone'] === 'function' &&
        typeof typedObj['lastUpdate']['isValid'] === 'function' &&
        typeof typedObj['lastUpdate']['invalidAt'] === 'function' &&
        typeof typedObj['lastUpdate']['hasAlignedHourOffset'] === 'function' &&
        typeof typedObj['lastUpdate']['creationData'] === 'function' &&
        typeof typedObj['lastUpdate']['parsingFlags'] === 'function' &&
        typeof typedObj['lastUpdate']['year'] === 'function' &&
        typeof typedObj['lastUpdate']['year'] === 'function' &&
        typeof typedObj['lastUpdate']['years'] === 'function' &&
        typeof typedObj['lastUpdate']['years'] === 'function' &&
        typeof typedObj['lastUpdate']['quarter'] === 'function' &&
        typeof typedObj['lastUpdate']['quarter'] === 'function' &&
        typeof typedObj['lastUpdate']['quarters'] === 'function' &&
        typeof typedObj['lastUpdate']['quarters'] === 'function' &&
        typeof typedObj['lastUpdate']['month'] === 'function' &&
        typeof typedObj['lastUpdate']['month'] === 'function' &&
        typeof typedObj['lastUpdate']['months'] === 'function' &&
        typeof typedObj['lastUpdate']['months'] === 'function' &&
        typeof typedObj['lastUpdate']['day'] === 'function' &&
        typeof typedObj['lastUpdate']['day'] === 'function' &&
        typeof typedObj['lastUpdate']['days'] === 'function' &&
        typeof typedObj['lastUpdate']['days'] === 'function' &&
        typeof typedObj['lastUpdate']['date'] === 'function' &&
        typeof typedObj['lastUpdate']['date'] === 'function' &&
        typeof typedObj['lastUpdate']['dates'] === 'function' &&
        typeof typedObj['lastUpdate']['dates'] === 'function' &&
        typeof typedObj['lastUpdate']['hour'] === 'function' &&
        typeof typedObj['lastUpdate']['hour'] === 'function' &&
        typeof typedObj['lastUpdate']['hours'] === 'function' &&
        typeof typedObj['lastUpdate']['hours'] === 'function' &&
        typeof typedObj['lastUpdate']['minute'] === 'function' &&
        typeof typedObj['lastUpdate']['minute'] === 'function' &&
        typeof typedObj['lastUpdate']['minutes'] === 'function' &&
        typeof typedObj['lastUpdate']['minutes'] === 'function' &&
        typeof typedObj['lastUpdate']['second'] === 'function' &&
        typeof typedObj['lastUpdate']['second'] === 'function' &&
        typeof typedObj['lastUpdate']['seconds'] === 'function' &&
        typeof typedObj['lastUpdate']['seconds'] === 'function' &&
        typeof typedObj['lastUpdate']['millisecond'] === 'function' &&
        typeof typedObj['lastUpdate']['millisecond'] === 'function' &&
        typeof typedObj['lastUpdate']['milliseconds'] === 'function' &&
        typeof typedObj['lastUpdate']['milliseconds'] === 'function' &&
        typeof typedObj['lastUpdate']['weekday'] === 'function' &&
        typeof typedObj['lastUpdate']['weekday'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeekday'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeekday'] === 'function' &&
        typeof typedObj['lastUpdate']['weekYear'] === 'function' &&
        typeof typedObj['lastUpdate']['weekYear'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeekYear'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeekYear'] === 'function' &&
        typeof typedObj['lastUpdate']['week'] === 'function' &&
        typeof typedObj['lastUpdate']['week'] === 'function' &&
        typeof typedObj['lastUpdate']['weeks'] === 'function' &&
        typeof typedObj['lastUpdate']['weeks'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeek'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeek'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeeks'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeeks'] === 'function' &&
        typeof typedObj['lastUpdate']['weeksInYear'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeeksInYear'] === 'function' &&
        typeof typedObj['lastUpdate']['isoWeeksInISOWeekYear'] === 'function' &&
        typeof typedObj['lastUpdate']['dayOfYear'] === 'function' &&
        typeof typedObj['lastUpdate']['dayOfYear'] === 'function' &&
        typeof typedObj['lastUpdate']['from'] === 'function' &&
        typeof typedObj['lastUpdate']['to'] === 'function' &&
        typeof typedObj['lastUpdate']['fromNow'] === 'function' &&
        typeof typedObj['lastUpdate']['toNow'] === 'function' &&
        typeof typedObj['lastUpdate']['diff'] === 'function' &&
        typeof typedObj['lastUpdate']['toArray'] === 'function' &&
        typeof typedObj['lastUpdate']['toDate'] === 'function' &&
        typeof typedObj['lastUpdate']['toISOString'] === 'function' &&
        typeof typedObj['lastUpdate']['inspect'] === 'function' &&
        typeof typedObj['lastUpdate']['toJSON'] === 'function' &&
        typeof typedObj['lastUpdate']['unix'] === 'function' &&
        typeof typedObj['lastUpdate']['isLeapYear'] === 'function' &&
        typeof typedObj['lastUpdate']['zone'] === 'function' &&
        typeof typedObj['lastUpdate']['zone'] === 'function' &&
        typeof typedObj['lastUpdate']['utcOffset'] === 'function' &&
        typeof typedObj['lastUpdate']['utcOffset'] === 'function' &&
        typeof typedObj['lastUpdate']['isUtcOffset'] === 'function' &&
        typeof typedObj['lastUpdate']['daysInMonth'] === 'function' &&
        typeof typedObj['lastUpdate']['isDST'] === 'function' &&
        typeof typedObj['lastUpdate']['zoneAbbr'] === 'function' &&
        typeof typedObj['lastUpdate']['zoneName'] === 'function' &&
        typeof typedObj['lastUpdate']['isBefore'] === 'function' &&
        typeof typedObj['lastUpdate']['isAfter'] === 'function' &&
        typeof typedObj['lastUpdate']['isSame'] === 'function' &&
        typeof typedObj['lastUpdate']['isSameOrAfter'] === 'function' &&
        typeof typedObj['lastUpdate']['isSameOrBefore'] === 'function' &&
        typeof typedObj['lastUpdate']['isBetween'] === 'function' &&
        typeof typedObj['lastUpdate']['lang'] === 'function' &&
        typeof typedObj['lastUpdate']['lang'] === 'function' &&
        typeof typedObj['lastUpdate']['locale'] === 'function' &&
        typeof typedObj['lastUpdate']['locale'] === 'function' &&
        typeof typedObj['lastUpdate']['localeData'] === 'function' &&
        typeof typedObj['lastUpdate']['isDSTShifted'] === 'function' &&
        typeof typedObj['lastUpdate']['max'] === 'function' &&
        typeof typedObj['lastUpdate']['max'] === 'function' &&
        typeof typedObj['lastUpdate']['min'] === 'function' &&
        typeof typedObj['lastUpdate']['min'] === 'function' &&
        typeof typedObj['lastUpdate']['get'] === 'function' &&
        typeof typedObj['lastUpdate']['set'] === 'function' &&
        typeof typedObj['lastUpdate']['set'] === 'function' &&
        typeof typedObj['lastUpdate']['toObject'] === 'function') ||
      typedObj['lastUpdate'] instanceof Date ||
      (Array.isArray(typedObj['lastUpdate']) &&
        typedObj['lastUpdate'].every(
          (e: any) => typeof e === 'string' || typeof e === 'number',
        )) ||
      (((typedObj['lastUpdate'] !== null &&
        typeof typedObj['lastUpdate'] === 'object') ||
        typeof typedObj['lastUpdate'] === 'function') &&
        (typeof typedObj['lastUpdate']['years'] === 'undefined' ||
          typeof typedObj['lastUpdate']['years'] === 'number') &&
        (typeof typedObj['lastUpdate']['year'] === 'undefined' ||
          typeof typedObj['lastUpdate']['year'] === 'number') &&
        (typeof typedObj['lastUpdate']['y'] === 'undefined' ||
          typeof typedObj['lastUpdate']['y'] === 'number') &&
        (typeof typedObj['lastUpdate']['months'] === 'undefined' ||
          typeof typedObj['lastUpdate']['months'] === 'number') &&
        (typeof typedObj['lastUpdate']['month'] === 'undefined' ||
          typeof typedObj['lastUpdate']['month'] === 'number') &&
        (typeof typedObj['lastUpdate']['M'] === 'undefined' ||
          typeof typedObj['lastUpdate']['M'] === 'number') &&
        (typeof typedObj['lastUpdate']['days'] === 'undefined' ||
          typeof typedObj['lastUpdate']['days'] === 'number') &&
        (typeof typedObj['lastUpdate']['day'] === 'undefined' ||
          typeof typedObj['lastUpdate']['day'] === 'number') &&
        (typeof typedObj['lastUpdate']['d'] === 'undefined' ||
          typeof typedObj['lastUpdate']['d'] === 'number') &&
        (typeof typedObj['lastUpdate']['dates'] === 'undefined' ||
          typeof typedObj['lastUpdate']['dates'] === 'number') &&
        (typeof typedObj['lastUpdate']['date'] === 'undefined' ||
          typeof typedObj['lastUpdate']['date'] === 'number') &&
        (typeof typedObj['lastUpdate']['D'] === 'undefined' ||
          typeof typedObj['lastUpdate']['D'] === 'number') &&
        (typeof typedObj['lastUpdate']['hours'] === 'undefined' ||
          typeof typedObj['lastUpdate']['hours'] === 'number') &&
        (typeof typedObj['lastUpdate']['hour'] === 'undefined' ||
          typeof typedObj['lastUpdate']['hour'] === 'number') &&
        (typeof typedObj['lastUpdate']['h'] === 'undefined' ||
          typeof typedObj['lastUpdate']['h'] === 'number') &&
        (typeof typedObj['lastUpdate']['minutes'] === 'undefined' ||
          typeof typedObj['lastUpdate']['minutes'] === 'number') &&
        (typeof typedObj['lastUpdate']['minute'] === 'undefined' ||
          typeof typedObj['lastUpdate']['minute'] === 'number') &&
        (typeof typedObj['lastUpdate']['m'] === 'undefined' ||
          typeof typedObj['lastUpdate']['m'] === 'number') &&
        (typeof typedObj['lastUpdate']['seconds'] === 'undefined' ||
          typeof typedObj['lastUpdate']['seconds'] === 'number') &&
        (typeof typedObj['lastUpdate']['second'] === 'undefined' ||
          typeof typedObj['lastUpdate']['second'] === 'number') &&
        (typeof typedObj['lastUpdate']['s'] === 'undefined' ||
          typeof typedObj['lastUpdate']['s'] === 'number') &&
        (typeof typedObj['lastUpdate']['milliseconds'] === 'undefined' ||
          typeof typedObj['lastUpdate']['milliseconds'] === 'number') &&
        (typeof typedObj['lastUpdate']['millisecond'] === 'undefined' ||
          typeof typedObj['lastUpdate']['millisecond'] === 'number') &&
        (typeof typedObj['lastUpdate']['ms'] === 'undefined' ||
          typeof typedObj['lastUpdate']['ms'] === 'number'))) &&
    (typeof typedObj['productionDate'] === 'undefined' ||
      typedObj['productionDate'] === null ||
      typeof typedObj['productionDate'] === 'string' ||
      typeof typedObj['productionDate'] === 'number' ||
      (typedObj['productionDate'] instanceof Object &&
        typeof typedObj['productionDate']['format'] === 'function' &&
        typeof typedObj['productionDate']['startOf'] === 'function' &&
        typeof typedObj['productionDate']['endOf'] === 'function' &&
        typeof typedObj['productionDate']['add'] === 'function' &&
        typeof typedObj['productionDate']['add'] === 'function' &&
        typeof typedObj['productionDate']['subtract'] === 'function' &&
        typeof typedObj['productionDate']['subtract'] === 'function' &&
        typeof typedObj['productionDate']['calendar'] === 'function' &&
        typeof typedObj['productionDate']['calendar'] === 'function' &&
        typeof typedObj['productionDate']['calendar'] === 'function' &&
        typeof typedObj['productionDate']['clone'] === 'function' &&
        typeof typedObj['productionDate']['valueOf'] === 'function' &&
        typeof typedObj['productionDate']['local'] === 'function' &&
        typeof typedObj['productionDate']['isLocal'] === 'function' &&
        typeof typedObj['productionDate']['utc'] === 'function' &&
        typeof typedObj['productionDate']['isUTC'] === 'function' &&
        typeof typedObj['productionDate']['isUtc'] === 'function' &&
        typeof typedObj['productionDate']['parseZone'] === 'function' &&
        typeof typedObj['productionDate']['isValid'] === 'function' &&
        typeof typedObj['productionDate']['invalidAt'] === 'function' &&
        typeof typedObj['productionDate']['hasAlignedHourOffset'] ===
          'function' &&
        typeof typedObj['productionDate']['creationData'] === 'function' &&
        typeof typedObj['productionDate']['parsingFlags'] === 'function' &&
        typeof typedObj['productionDate']['year'] === 'function' &&
        typeof typedObj['productionDate']['year'] === 'function' &&
        typeof typedObj['productionDate']['years'] === 'function' &&
        typeof typedObj['productionDate']['years'] === 'function' &&
        typeof typedObj['productionDate']['quarter'] === 'function' &&
        typeof typedObj['productionDate']['quarter'] === 'function' &&
        typeof typedObj['productionDate']['quarters'] === 'function' &&
        typeof typedObj['productionDate']['quarters'] === 'function' &&
        typeof typedObj['productionDate']['month'] === 'function' &&
        typeof typedObj['productionDate']['month'] === 'function' &&
        typeof typedObj['productionDate']['months'] === 'function' &&
        typeof typedObj['productionDate']['months'] === 'function' &&
        typeof typedObj['productionDate']['day'] === 'function' &&
        typeof typedObj['productionDate']['day'] === 'function' &&
        typeof typedObj['productionDate']['days'] === 'function' &&
        typeof typedObj['productionDate']['days'] === 'function' &&
        typeof typedObj['productionDate']['date'] === 'function' &&
        typeof typedObj['productionDate']['date'] === 'function' &&
        typeof typedObj['productionDate']['dates'] === 'function' &&
        typeof typedObj['productionDate']['dates'] === 'function' &&
        typeof typedObj['productionDate']['hour'] === 'function' &&
        typeof typedObj['productionDate']['hour'] === 'function' &&
        typeof typedObj['productionDate']['hours'] === 'function' &&
        typeof typedObj['productionDate']['hours'] === 'function' &&
        typeof typedObj['productionDate']['minute'] === 'function' &&
        typeof typedObj['productionDate']['minute'] === 'function' &&
        typeof typedObj['productionDate']['minutes'] === 'function' &&
        typeof typedObj['productionDate']['minutes'] === 'function' &&
        typeof typedObj['productionDate']['second'] === 'function' &&
        typeof typedObj['productionDate']['second'] === 'function' &&
        typeof typedObj['productionDate']['seconds'] === 'function' &&
        typeof typedObj['productionDate']['seconds'] === 'function' &&
        typeof typedObj['productionDate']['millisecond'] === 'function' &&
        typeof typedObj['productionDate']['millisecond'] === 'function' &&
        typeof typedObj['productionDate']['milliseconds'] === 'function' &&
        typeof typedObj['productionDate']['milliseconds'] === 'function' &&
        typeof typedObj['productionDate']['weekday'] === 'function' &&
        typeof typedObj['productionDate']['weekday'] === 'function' &&
        typeof typedObj['productionDate']['isoWeekday'] === 'function' &&
        typeof typedObj['productionDate']['isoWeekday'] === 'function' &&
        typeof typedObj['productionDate']['weekYear'] === 'function' &&
        typeof typedObj['productionDate']['weekYear'] === 'function' &&
        typeof typedObj['productionDate']['isoWeekYear'] === 'function' &&
        typeof typedObj['productionDate']['isoWeekYear'] === 'function' &&
        typeof typedObj['productionDate']['week'] === 'function' &&
        typeof typedObj['productionDate']['week'] === 'function' &&
        typeof typedObj['productionDate']['weeks'] === 'function' &&
        typeof typedObj['productionDate']['weeks'] === 'function' &&
        typeof typedObj['productionDate']['isoWeek'] === 'function' &&
        typeof typedObj['productionDate']['isoWeek'] === 'function' &&
        typeof typedObj['productionDate']['isoWeeks'] === 'function' &&
        typeof typedObj['productionDate']['isoWeeks'] === 'function' &&
        typeof typedObj['productionDate']['weeksInYear'] === 'function' &&
        typeof typedObj['productionDate']['isoWeeksInYear'] === 'function' &&
        typeof typedObj['productionDate']['isoWeeksInISOWeekYear'] ===
          'function' &&
        typeof typedObj['productionDate']['dayOfYear'] === 'function' &&
        typeof typedObj['productionDate']['dayOfYear'] === 'function' &&
        typeof typedObj['productionDate']['from'] === 'function' &&
        typeof typedObj['productionDate']['to'] === 'function' &&
        typeof typedObj['productionDate']['fromNow'] === 'function' &&
        typeof typedObj['productionDate']['toNow'] === 'function' &&
        typeof typedObj['productionDate']['diff'] === 'function' &&
        typeof typedObj['productionDate']['toArray'] === 'function' &&
        typeof typedObj['productionDate']['toDate'] === 'function' &&
        typeof typedObj['productionDate']['toISOString'] === 'function' &&
        typeof typedObj['productionDate']['inspect'] === 'function' &&
        typeof typedObj['productionDate']['toJSON'] === 'function' &&
        typeof typedObj['productionDate']['unix'] === 'function' &&
        typeof typedObj['productionDate']['isLeapYear'] === 'function' &&
        typeof typedObj['productionDate']['zone'] === 'function' &&
        typeof typedObj['productionDate']['zone'] === 'function' &&
        typeof typedObj['productionDate']['utcOffset'] === 'function' &&
        typeof typedObj['productionDate']['utcOffset'] === 'function' &&
        typeof typedObj['productionDate']['isUtcOffset'] === 'function' &&
        typeof typedObj['productionDate']['daysInMonth'] === 'function' &&
        typeof typedObj['productionDate']['isDST'] === 'function' &&
        typeof typedObj['productionDate']['zoneAbbr'] === 'function' &&
        typeof typedObj['productionDate']['zoneName'] === 'function' &&
        typeof typedObj['productionDate']['isBefore'] === 'function' &&
        typeof typedObj['productionDate']['isAfter'] === 'function' &&
        typeof typedObj['productionDate']['isSame'] === 'function' &&
        typeof typedObj['productionDate']['isSameOrAfter'] === 'function' &&
        typeof typedObj['productionDate']['isSameOrBefore'] === 'function' &&
        typeof typedObj['productionDate']['isBetween'] === 'function' &&
        typeof typedObj['productionDate']['lang'] === 'function' &&
        typeof typedObj['productionDate']['lang'] === 'function' &&
        typeof typedObj['productionDate']['locale'] === 'function' &&
        typeof typedObj['productionDate']['locale'] === 'function' &&
        typeof typedObj['productionDate']['localeData'] === 'function' &&
        typeof typedObj['productionDate']['isDSTShifted'] === 'function' &&
        typeof typedObj['productionDate']['max'] === 'function' &&
        typeof typedObj['productionDate']['max'] === 'function' &&
        typeof typedObj['productionDate']['min'] === 'function' &&
        typeof typedObj['productionDate']['min'] === 'function' &&
        typeof typedObj['productionDate']['get'] === 'function' &&
        typeof typedObj['productionDate']['set'] === 'function' &&
        typeof typedObj['productionDate']['set'] === 'function' &&
        typeof typedObj['productionDate']['toObject'] === 'function') ||
      typedObj['productionDate'] instanceof Date ||
      (Array.isArray(typedObj['productionDate']) &&
        typedObj['productionDate'].every(
          (e: any) => typeof e === 'string' || typeof e === 'number',
        )) ||
      (((typedObj['productionDate'] !== null &&
        typeof typedObj['productionDate'] === 'object') ||
        typeof typedObj['productionDate'] === 'function') &&
        (typeof typedObj['productionDate']['years'] === 'undefined' ||
          typeof typedObj['productionDate']['years'] === 'number') &&
        (typeof typedObj['productionDate']['year'] === 'undefined' ||
          typeof typedObj['productionDate']['year'] === 'number') &&
        (typeof typedObj['productionDate']['y'] === 'undefined' ||
          typeof typedObj['productionDate']['y'] === 'number') &&
        (typeof typedObj['productionDate']['months'] === 'undefined' ||
          typeof typedObj['productionDate']['months'] === 'number') &&
        (typeof typedObj['productionDate']['month'] === 'undefined' ||
          typeof typedObj['productionDate']['month'] === 'number') &&
        (typeof typedObj['productionDate']['M'] === 'undefined' ||
          typeof typedObj['productionDate']['M'] === 'number') &&
        (typeof typedObj['productionDate']['days'] === 'undefined' ||
          typeof typedObj['productionDate']['days'] === 'number') &&
        (typeof typedObj['productionDate']['day'] === 'undefined' ||
          typeof typedObj['productionDate']['day'] === 'number') &&
        (typeof typedObj['productionDate']['d'] === 'undefined' ||
          typeof typedObj['productionDate']['d'] === 'number') &&
        (typeof typedObj['productionDate']['dates'] === 'undefined' ||
          typeof typedObj['productionDate']['dates'] === 'number') &&
        (typeof typedObj['productionDate']['date'] === 'undefined' ||
          typeof typedObj['productionDate']['date'] === 'number') &&
        (typeof typedObj['productionDate']['D'] === 'undefined' ||
          typeof typedObj['productionDate']['D'] === 'number') &&
        (typeof typedObj['productionDate']['hours'] === 'undefined' ||
          typeof typedObj['productionDate']['hours'] === 'number') &&
        (typeof typedObj['productionDate']['hour'] === 'undefined' ||
          typeof typedObj['productionDate']['hour'] === 'number') &&
        (typeof typedObj['productionDate']['h'] === 'undefined' ||
          typeof typedObj['productionDate']['h'] === 'number') &&
        (typeof typedObj['productionDate']['minutes'] === 'undefined' ||
          typeof typedObj['productionDate']['minutes'] === 'number') &&
        (typeof typedObj['productionDate']['minute'] === 'undefined' ||
          typeof typedObj['productionDate']['minute'] === 'number') &&
        (typeof typedObj['productionDate']['m'] === 'undefined' ||
          typeof typedObj['productionDate']['m'] === 'number') &&
        (typeof typedObj['productionDate']['seconds'] === 'undefined' ||
          typeof typedObj['productionDate']['seconds'] === 'number') &&
        (typeof typedObj['productionDate']['second'] === 'undefined' ||
          typeof typedObj['productionDate']['second'] === 'number') &&
        (typeof typedObj['productionDate']['s'] === 'undefined' ||
          typeof typedObj['productionDate']['s'] === 'number') &&
        (typeof typedObj['productionDate']['milliseconds'] === 'undefined' ||
          typeof typedObj['productionDate']['milliseconds'] === 'number') &&
        (typeof typedObj['productionDate']['millisecond'] === 'undefined' ||
          typeof typedObj['productionDate']['millisecond'] === 'number') &&
        (typeof typedObj['productionDate']['ms'] === 'undefined' ||
          typeof typedObj['productionDate']['ms'] === 'number'))) &&
    (typeof typedObj['deleted'] === 'undefined' ||
      typedObj['deleted'] === false ||
      typedObj['deleted'] === true)
  )
}

export function isDailyDiaryValue(obj: unknown): obj is DailyDiaryValue {
  const typedObj = obj as DailyDiaryValue
  return (
    (isColumnComment(typedObj) as boolean) &&
    (typeof typedObj['columnProcess'] === 'undefined' ||
      typedObj['columnProcess'] === 'DMX' ||
      typedObj['columnProcess'] === 'HF' ||
      typedObj['columnProcess'] === 'JTC' ||
      typedObj['columnProcess'] === 'KS' ||
      typedObj['columnProcess'] === 'PFA' ||
      typedObj['columnProcess'] === 'PFC' ||
      typedObj['columnProcess'] === 'SBP' ||
      typedObj['columnProcess'] === 'SMX' ||
      typedObj['columnProcess'] === 'TCT' ||
      typedObj['columnProcess'] === 'VBF' ||
      typedObj['columnProcess'] === 'EPF' ||
      typedObj['columnProcess'] === 'TLK')
  )
}
